import { EventTypes } from 'utils/constants/eventTypes';
import { IMapTemplates, MapTemplate } from 'types';

import LittlePigsMath from 'style/imgs/nextRoom/little-pigs/math.png';
import LittlePigsArt from 'style/imgs/nextRoom/little-pigs/art.png';
import LittlePigsCafeteria from 'style/imgs/nextRoom/little-pigs/cafeteria.png';
import LittlePigsGym from 'style/imgs/nextRoom/little-pigs/gym.png';
import LittlePigsLanguageArt from 'style/imgs/nextRoom/little-pigs/language-arts.png';
import LittlePigsLibrary from 'style/imgs/nextRoom/little-pigs/library.png';
import LittlePigsMakersPlace from 'style/imgs/nextRoom/little-pigs/makers-place.png';
import LittlePigsMultipurpose from 'style/imgs/nextRoom/little-pigs/multi-purpose.png';
import LittlePigsMusic from 'style/imgs/nextRoom/little-pigs/music.png';
import LittlePigsPlayground from 'style/imgs/nextRoom/little-pigs/playground.png';
import LittlePigsScience from 'style/imgs/nextRoom/little-pigs/science.png';
import LittlePigsSocial from 'style/imgs/nextRoom/little-pigs/social-studies.png';

import FantasyLandMath from 'style/imgs/nextRoom/fantasy-land/math.png';
import FantasyLandArt from 'style/imgs/nextRoom/fantasy-land/art.png';
import FantasyLandCafeteria from 'style/imgs/nextRoom/fantasy-land/cafeteria.png';
import FantasyLandGym from 'style/imgs/nextRoom/fantasy-land/gym.png';
import FantasyLandLanguageArt from 'style/imgs/nextRoom/fantasy-land/language-arts.png';
import FantasyLandLibrary from 'style/imgs/nextRoom/fantasy-land/library.png';
import FantasyLandMakersPlace from 'style/imgs/nextRoom/fantasy-land/makers-place.png';
import FantasyLandMultipurpose from 'style/imgs/nextRoom/fantasy-land/multi-purpose.png';
import FantasyLandMusic from 'style/imgs/nextRoom/fantasy-land/music.png';
import FantasyLandPlayground from 'style/imgs/nextRoom/fantasy-land/playground.png';
import FantasyLandScience from 'style/imgs/nextRoom/fantasy-land/science.png';
import FantasyLandSocial from 'style/imgs/nextRoom/fantasy-land/social-studies.png';

import UnderseaMath from 'style/imgs/nextRoom/undersea/math.png';
import UnderseaArt from 'style/imgs/nextRoom/undersea/art.png';
import UnderseaCafeteria from 'style/imgs/nextRoom/undersea/cafeteria.png';
import UnderseaGym from 'style/imgs/nextRoom/undersea/gym.png';
import UnderseaLanguageArt from 'style/imgs/nextRoom/undersea/language-arts.png';
import UnderseaLibrary from 'style/imgs/nextRoom/undersea/library.png';
import UnderseaMakersPlace from 'style/imgs/nextRoom/undersea/makers-place.png';
import UnderseaMultipurpose from 'style/imgs/nextRoom/undersea/multi-purpose.png';
import UnderseaMusic from 'style/imgs/nextRoom/undersea/music.png';
import UnderseaPlayground from 'style/imgs/nextRoom/undersea/playground.png';
import UnderseaScience from 'style/imgs/nextRoom/undersea/science.png';
import UnderseaSocial from 'style/imgs/nextRoom/undersea/social-studies.png';

import FutureCityMath from 'style/imgs/nextRoom/future-city/math.png';
import FutureCityArt from 'style/imgs/nextRoom/future-city/art.png';
import FutureCityCafeteria from 'style/imgs/nextRoom/future-city/cafeteria.png';
import FutureCityGym from 'style/imgs/nextRoom/future-city/gym.png';
import FutureCityLanguageArt from 'style/imgs/nextRoom/future-city/language-arts.png';
import FutureCityLibrary from 'style/imgs/nextRoom/future-city/library.png';
import FutureCityMakersPlace from 'style/imgs/nextRoom/future-city/makers-place.png';
import FutureCityMultipurpose from 'style/imgs/nextRoom/future-city/multi-purpose.png';
import FutureCityMusic from 'style/imgs/nextRoom/future-city/music.png';
import FutureCityPlayground from 'style/imgs/nextRoom/future-city/playground.png';
import FutureCityScience from 'style/imgs/nextRoom/future-city/science.png';
import FutureCitySocial from 'style/imgs/nextRoom/future-city/social-studies.png';

interface ISubjects {
  art: string;
  cafeteria: string;
  gym: string;
  math: string;
  languageArt: string;
  library: string;
  makersPlace: string;
  multiPurpose: string;
  music: string;
  playGround: string;
  science: string;
  social: string;
}

const littlePigsSubjects: ISubjects = {
  art: LittlePigsArt,
  cafeteria: LittlePigsCafeteria,
  gym: LittlePigsGym,
  languageArt: LittlePigsLanguageArt,
  library: LittlePigsLibrary,
  makersPlace: LittlePigsMakersPlace,
  multiPurpose: LittlePigsMultipurpose,
  music: LittlePigsMusic,
  math: LittlePigsMath,
  playGround: LittlePigsPlayground,
  science: LittlePigsScience,
  social: LittlePigsSocial,
};

const fantasyLandSubjects: ISubjects = {
  art: FantasyLandArt,
  cafeteria: FantasyLandCafeteria,
  gym: FantasyLandGym,
  languageArt: FantasyLandLanguageArt,
  library: FantasyLandLibrary,
  makersPlace: FantasyLandMakersPlace,
  multiPurpose: FantasyLandMultipurpose,
  music: FantasyLandMusic,
  math: FantasyLandMath,
  playGround: FantasyLandPlayground,
  science: FantasyLandScience,
  social: FantasyLandSocial,
};

const underseaSubjects: ISubjects = {
  art: UnderseaArt,
  cafeteria: UnderseaCafeteria,
  gym: UnderseaGym,
  languageArt: UnderseaLanguageArt,
  library: UnderseaLibrary,
  makersPlace: UnderseaMakersPlace,
  multiPurpose: UnderseaMultipurpose,
  music: UnderseaMusic,
  math: UnderseaMath,
  playGround: UnderseaPlayground,
  science: UnderseaScience,
  social: UnderseaSocial,
};

const futureCitySubjects: ISubjects = {
  art: FutureCityArt,
  cafeteria: FutureCityCafeteria,
  gym: FutureCityGym,
  languageArt: FutureCityLanguageArt,
  library: FutureCityLibrary,
  makersPlace: FutureCityMakersPlace,
  multiPurpose: FutureCityMultipurpose,
  music: FutureCityMusic,
  math: FutureCityMath,
  playGround: FutureCityPlayground,
  science: FutureCityScience,
  social: FutureCitySocial,
};

const subjects: IMapTemplates<ISubjects> = {
  littlePigs: littlePigsSubjects,
  fantasyLand: fantasyLandSubjects,
  undersea: underseaSubjects,
  futureCity: futureCitySubjects,
  design5: fantasyLandSubjects,
  design6: fantasyLandSubjects,
  design7: fantasyLandSubjects,
  design8: fantasyLandSubjects,
};

export const getUrl = (
  subject: EventTypes,
  mapTemplate: MapTemplate
): string => {
  if (subject === EventTypes.socialStudies) {
    return subjects[mapTemplate].social;
  }
  if (subject === EventTypes.math) {
    return subjects[mapTemplate].math;
  }
  if (subject === EventTypes.art) {
    return subjects[mapTemplate].art;
  }
  if (subject === EventTypes.cafeteria) {
    return subjects[mapTemplate].cafeteria;
  }
  if (subject === EventTypes.gym) {
    return subjects[mapTemplate].gym;
  }
  if (subject === EventTypes.languageArts) {
    return subjects[mapTemplate].languageArt;
  }
  if (subject === EventTypes.library) {
    return subjects[mapTemplate].library;
  }
  if (subject === EventTypes.makersplace) {
    return subjects[mapTemplate].makersPlace;
  }
  if (subject === EventTypes.multipurpose) {
    return subjects[mapTemplate].multiPurpose;
  }
  if (subject === EventTypes.music) {
    return subjects[mapTemplate].music;
  }
  if (subject === EventTypes.playground) {
    return subjects[mapTemplate].playGround;
  }
  if (subject === EventTypes.science) {
    return subjects[mapTemplate].science;
  }
  return '';
};

export const getUpperCase = (str: string): string => {
  if (!str) return str;
  return str[0].toUpperCase() + str.slice(1);
};
